<template>
  <footer class="footer">
    <b-row>
      <b-col>
        <div>
          <a title="CSIRO AEHRC" href="https://aehrc.csiro.au/">
            <img alt="CSIRO logo" src="@/assets/img/AEHRC_logo.svg" />
          </a>
        </div>
      </b-col>
      <b-col>
        <div>
          <ul class="footer-links">
            <span class="footer-title">About us</span>
            <li><router-link class="link link-hover" to="/">Home</router-link></li>
            <li>
              <a class="link link-hover" title="Contact Us" :href="mailToAddress">Contact Us</a>
            </li>
          </ul>
        </div>
      </b-col>
      <b-col>
        <div>
          <ul class="footer-links">
            <span class="footer-title">Links</span>
            <li><a class="link link-hover" title="CSIRO" href="https://www.csiro.au/">CSIRO</a></li>
            <li>
              <a
                class="link link-hover"
                title="HeIDI"
                href="https://metronorth.health.qld.gov.au/infectious-diseases-institute/"
                >HeIDI</a
              >
            </li>
          </ul>
        </div>
      </b-col>
      <b-col>
        <div>
          <ul class="footer-links">
            <span class="footer-title">Legal</span>
            <li><router-link class="link link-hover" to="/terms">Terms of use</router-link></li>
            <li><router-link class="link link-hover" to="/cookies">Cookie Policy</router-link></li>
          </ul>
        </div>
      </b-col>
    </b-row>
    <b-row align-h="center">
      <p class="small text-white-50">CSIRO Copyright (c) {{ year }}</p>
      <p class="small text-white-50">Version {{ version }}</p>
    </b-row>
  </footer>
</template>

<script setup lang="ts">
import { MAILTO, VERSION } from '@/main';

defineOptions({ name: 'FooterComponent' });

const mailToAddress = 'mailto:' + MAILTO + '?subject=HeIDI%20Dosing%20App%20Query';
const version = VERSION;
const year = new Date().getFullYear();
</script>

<style scoped>
.footer {
  margin-top: 20px;
  padding-top: 20px;
  background-color: #2c3e50;
}

.footer-title {
  font-variant: all-small-caps;
  text-align: left;
  color: #00a8cc;
}

.footer-links {
  list-style: none;
  text-align: center;
  font-size: 0.9em;
}
</style>
